import { Route } from 'react-router-dom';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { AdminLayout } from '@/layouts/AdminLayout';
import { AdminDashboard } from '@/pages/admin/Dashboard';
import { ArticleStatistics } from '@/pages/admin/ArticleStatistics';
import { ArticleTopViews } from '@/pages/admin/ArticleTopViews';
import { UserManagement } from '@/pages/admin/UserManagement';
import { CreateEditor } from '@/pages/admin/CreateEditor';

export function AdminRouter() {
  return (
    <>
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute roles={['admin']}>
            <AdminLayout>
              <AdminDashboard />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/article-statistics"
        element={
          <ProtectedRoute roles={['admin']}>
            <AdminLayout>
              <ArticleStatistics />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/article-top-views"
        element={
          <ProtectedRoute roles={['admin']}>
            <AdminLayout>
              <ArticleTopViews />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <ProtectedRoute roles={['admin']}>
            <AdminLayout>
              <UserManagement />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users/create"
        element={
          <ProtectedRoute roles={['admin']}>
            <AdminLayout>
              <CreateEditor />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
    </>
  );
}
